import {get, post, put, deleteMethod} from "@iflat/iflat-ui/src/api/methods";

export default {
  async getItems(params) {
    const res = await get('/inspectionSteps', {params})
    return res.data
  },
  async createItem(data) {
    const res = await post('/inspectionSteps', data)
    return res.data
  },
  async updateItem(inspectionStepId, data, params) {
    const res = await put(`/inspectionSteps/${inspectionStepId}`, data, {params})
    return res.data
  },
  deleteItem(inspectionStepId) {
    return deleteMethod(`/inspectionSteps/${inspectionStepId}`)
  },
}